"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaResponseApiTypeEnum = exports.MetaResponseApiContentProviderEnum = exports.MetaResponseApiBoughtStatusEnum = exports.MetaResponseApiAgeRestrictionEnum = exports.LinkApiLinkTypeEnum = exports.IntroTextApiTypeEnum = exports.InputElementApi1TypeEnum = exports.InputElementApiTypeEnum = exports.GroupElementApiGroupTypeEnum = exports.FavoriteVodShelfApi1TypeEnum = exports.FavoriteVodShelfApiTypeEnum = exports.FavoriteChannelsShelfApi1TypeEnum = exports.FavoriteChannelsShelfApiTypeEnum = exports.ExpandableApi1ItemTypeEnum = exports.ExpandableApi1GroupTypeEnum = exports.ExpandableApiItemTypeEnum = exports.ExpandableApiGroupTypeEnum = exports.EpisodeLinkApi1LinkTypeEnum = exports.EpisodeLinkApiLinkTypeEnum = exports.EpisodeInfoApiBoughtStatusEnum = exports.EpisodeApiContentProviderEnum = exports.EpisodeApiAgeRestrictionEnum = exports.EntityEntityTypeEnum = exports.ElementApiTypeEnum = exports.DividerElementApi1TypeEnum = exports.DividerElementApiTypeEnum = exports.DividerApi1GroupTypeEnum = exports.DividerApiGroupTypeEnum = exports.DeeplinkShelfApi1TypeEnum = exports.DeeplinkShelfApiTypeEnum = exports.DateTimeSpecSymbolicDaytimeEnum = exports.ContentCardApiTypeEnum = exports.ContentCardApiBoughtStatusEnum = exports.CheckboxElementApi1TypeEnum = exports.CheckboxElementApiTypeEnum = exports.ChannelsShelfApi1TypeEnum = exports.ChannelsShelfApiTypeEnum = exports.ChannelLinkApi1LinkTypeEnum = exports.ChannelLinkApiLinkTypeEnum = exports.CastLinkApi1LinkTypeEnum = exports.CastLinkApiLinkTypeEnum = exports.CarouselShelfApi1TypeEnum = exports.CarouselShelfApiTypeEnum = exports.CallToActionTypeEnum = exports.BookmarkShelfApi1TypeEnum = exports.BookmarkShelfApiTypeEnum = exports.BlockShelfApi1TypeEnum = exports.BlockShelfApiTypeEnum = exports.ActionElementApi1TypeEnum = exports.ActionElementApiTypeEnum = void 0;
exports.ShelfBlockItemApiSaleModelsEnum = exports.ShelfBlockItemApiAgeRestrictionEnum = exports.ShelfApiTypeEnum = exports.SeriesLinkApi1LinkTypeEnum = exports.SeriesLinkApiLinkTypeEnum = exports.SeriesContentCardApi1TypeEnum = exports.SeriesContentCardApi1BoughtStatusEnum = exports.SeriesContentCardApiTypeEnum = exports.SeriesContentCardApiBoughtStatusEnum = exports.SelectElementApi1TypeEnum = exports.SelectElementApiTypeEnum = exports.SeasonLinkApi1LinkTypeEnum = exports.SeasonLinkApiLinkTypeEnum = exports.SeasonInfoApiBoughtStatusEnum = exports.SeasonApiContentProviderEnum = exports.SeasonApiBoughtStatusEnum = exports.SeasonApiAgeRestrictionEnum = exports.SearchVodShelfApi1TypeEnum = exports.SearchVodShelfApiTypeEnum = exports.SearchProgramsShelfApi1TypeEnum = exports.SearchProgramsShelfApiTypeEnum = exports.SearchChannelsShelfApi1TypeEnum = exports.SearchChannelsShelfApiTypeEnum = exports.SearchCatchupsShelfApi1TypeEnum = exports.SearchCatchupsShelfApiTypeEnum = exports.ScreensaverShelfApi1TypeEnum = exports.ScreensaverShelfApiTypeEnum = exports.ResultListItemRatingEnum = exports.ResultListItemEntityTypeEnum = exports.RangeElementApi1TypeEnum = exports.RangeElementApiTypeEnum = exports.PromoShelfApi1TypeEnum = exports.PromoShelfApiTypeEnum = exports.PromoCodeLinkApi1LinkTypeEnum = exports.PromoCodeLinkApiLinkTypeEnum = exports.ProgramLinkApi1LinkTypeEnum = exports.ProgramLinkApiLinkTypeEnum = exports.PreferenceRequestApiResultEnum = exports.PersonApiGenderEnum = exports.PageInfoApiSlugEnum = exports.PageApiSlugEnum = exports.OperatorMediaQueryResponseQueryIntentEnum = exports.NowOnTvShelfApi1TypeEnum = exports.NowOnTvShelfApiTypeEnum = exports.MovieLinkApi1LinkTypeEnum = exports.MovieLinkApiLinkTypeEnum = exports.MovieContentCardApi1TypeEnum = exports.MovieContentCardApi1BoughtStatusEnum = exports.MovieContentCardApiTypeEnum = exports.MovieContentCardApiBoughtStatusEnum = void 0;
exports.ShelfSeriesItemApi1TypeEnum = exports.ShelfSeriesItemApi1SaleModelsEnum = exports.ShelfSeriesItemApi1AgeRestrictionEnum = exports.ShelfSeriesItemApiTypeEnum = exports.ShelfSeriesItemApiSaleModelsEnum = exports.ShelfSeriesItemApiAgeRestrictionEnum = exports.ShelfSeasonItemApi1TypeEnum = exports.ShelfSeasonItemApi1SaleModelsEnum = exports.ShelfSeasonItemApi1AgeRestrictionEnum = exports.ShelfSeasonItemApiTypeEnum = exports.ShelfSeasonItemApiSaleModelsEnum = exports.ShelfSeasonItemApiAgeRestrictionEnum = exports.ShelfScreensaverBannerItemApi1TypeEnum = exports.ShelfScreensaverBannerItemApi1SaleModelsEnum = exports.ShelfScreensaverBannerItemApi1AgeRestrictionEnum = exports.ShelfScreensaverBannerItemApiTypeEnum = exports.ShelfScreensaverBannerItemApiSaleModelsEnum = exports.ShelfScreensaverBannerItemApiAgeRestrictionEnum = exports.ShelfProgramItemApi1TypeEnum = exports.ShelfProgramItemApi1AgeRestrictionEnum = exports.ShelfProgramItemApiTypeEnum = exports.ShelfProgramItemApiAgeRestrictionEnum = exports.ShelfMovieItemApi1TypeEnum = exports.ShelfMovieItemApi1SaleModelsEnum = exports.ShelfMovieItemApi1AgeRestrictionEnum = exports.ShelfMovieItemApiTypeEnum = exports.ShelfMovieItemApiSaleModelsEnum = exports.ShelfMovieItemApiAgeRestrictionEnum = exports.ShelfItemApiTypeEnum = exports.ShelfItemApiAgeRestrictionEnum = exports.ShelfEpisodeItemApi1TypeEnum = exports.ShelfEpisodeItemApi1SaleModelsEnum = exports.ShelfEpisodeItemApi1AgeRestrictionEnum = exports.ShelfEpisodeItemApiTypeEnum = exports.ShelfEpisodeItemApiSaleModelsEnum = exports.ShelfEpisodeItemApiAgeRestrictionEnum = exports.ShelfCoverItemApi1TypeEnum = exports.ShelfCoverItemApi1ShapeEnum = exports.ShelfCoverItemApi1AgeRestrictionEnum = exports.ShelfCoverItemApiTypeEnum = exports.ShelfCoverItemApiShapeEnum = exports.ShelfCoverItemApiAgeRestrictionEnum = exports.ShelfChannelItemApi1TypeEnum = exports.ShelfChannelItemApi1AgeRestrictionEnum = exports.ShelfChannelItemApiTypeEnum = exports.ShelfChannelItemApiAgeRestrictionEnum = exports.ShelfBlockItemApi1TypeEnum = exports.ShelfBlockItemApi1SaleModelsEnum = exports.ShelfBlockItemApi1AgeRestrictionEnum = exports.ShelfBlockItemApiTypeEnum = void 0;
exports.GarconControllerApi = exports.GarconControllerApiFactory = exports.GarconControllerApiFp = exports.GarconControllerApiAxiosParamCreator = exports.FiltersApi = exports.FiltersApiFactory = exports.FiltersApiFp = exports.FiltersApiAxiosParamCreator = exports.ContentsApi = exports.ContentsApiFactory = exports.ContentsApiFp = exports.ContentsApiAxiosParamCreator = exports.ActorFrameLabelsApi = exports.ActorFrameLabelsApiFactory = exports.ActorFrameLabelsApiFp = exports.ActorFrameLabelsApiAxiosParamCreator = exports.VodShelfLinkApi1LinkTypeEnum = exports.VodShelfLinkApiLinkTypeEnum = exports.VodShelfApi1TypeEnum = exports.VodShelfApiTypeEnum = exports.UrlLinkApi1LinkTypeEnum = exports.UrlLinkApiLinkTypeEnum = exports.SuperShelfApi1TypeEnum = exports.SuperShelfApiTypeEnum = exports.SubscriptionListLinkApi1LinkTypeEnum = exports.SubscriptionListLinkApiLinkTypeEnum = exports.SubscriptionLinkApi1LinkTypeEnum = exports.SubscriptionLinkApiLinkTypeEnum = exports.SubViewApi1ItemTypeEnum = exports.SubViewApi1GroupTypeEnum = exports.SubViewApiItemTypeEnum = exports.SubViewApiGroupTypeEnum = exports.StructuredQueryQueryIntentEnum = exports.StructuredQueryMediaTypeEnum = exports.SkippingFragmentApiTypeEnum = exports.ShelfVodItemApiTypeEnum = exports.ShelfVodItemApiSaleModelsEnum = exports.ShelfVodItemApiAgeRestrictionEnum = exports.ShelfVideoBannerItemApi1TypeEnum = exports.ShelfVideoBannerItemApi1SaleModelsEnum = exports.ShelfVideoBannerItemApi1AgeRestrictionEnum = exports.ShelfVideoBannerItemApiTypeEnum = exports.ShelfVideoBannerItemApiSaleModelsEnum = exports.ShelfVideoBannerItemApiAgeRestrictionEnum = exports.ShelfSimpleBannerItemApi1TypeEnum = exports.ShelfSimpleBannerItemApi1SaleModelsEnum = exports.ShelfSimpleBannerItemApi1AgeRestrictionEnum = exports.ShelfSimpleBannerItemApiTypeEnum = exports.ShelfSimpleBannerItemApiSaleModelsEnum = exports.ShelfSimpleBannerItemApiAgeRestrictionEnum = void 0;
exports.ShelvesApi = exports.ShelvesApiFactory = exports.ShelvesApiFp = exports.ShelvesApiAxiosParamCreator = exports.SearchApi = exports.SearchApiFactory = exports.SearchApiFp = exports.SearchApiAxiosParamCreator = exports.RemindersApi = exports.RemindersApiFactory = exports.RemindersApiFp = exports.RemindersApiAxiosParamCreator = exports.RatingApi = exports.RatingApiFactory = exports.RatingApiFp = exports.RatingApiAxiosParamCreator = exports.PreferenceApi = exports.PreferenceApiFactory = exports.PreferenceApiFp = exports.PreferenceApiAxiosParamCreator = exports.PagesApi = exports.PagesApiFactory = exports.PagesApiFp = exports.PagesApiAxiosParamCreator = exports.OnboardingApi = exports.OnboardingApiFactory = exports.OnboardingApiFp = exports.OnboardingApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.ActionElementApiTypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.ActionElementApi1TypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.BlockShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.BlockShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.BookmarkShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.BookmarkShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.CallToActionTypeEnum = {
    CancelRecording: 'CANCEL_RECORDING',
    DeleteRecording: 'DELETE_RECORDING',
    OpenApp: 'OPEN_APP',
    Play: 'PLAY',
    PlayTrailer: 'PLAY_TRAILER',
    Record: 'RECORD',
    Restart: 'RESTART',
    ViewAllEpisodes: 'VIEW_ALL_EPISODES'
};
exports.CarouselShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.CarouselShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.CastLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.CastLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.ChannelLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.ChannelLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.ChannelsShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.ChannelsShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.CheckboxElementApiTypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.CheckboxElementApi1TypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.ContentCardApiBoughtStatusEnum = {
    Blocked: 'BLOCKED',
    Free: 'FREE',
    Fvod: 'FVOD',
    IsAvod: 'IS_AVOD',
    PartiallyPurchased: 'PARTIALLY_PURCHASED',
    Purchased: 'PURCHASED',
    Unpurchased: 'UNPURCHASED'
};
exports.ContentCardApiTypeEnum = {
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Season: 'SEASON',
    Series: 'SERIES'
};
exports.DateTimeSpecSymbolicDaytimeEnum = {
    Afternoon: 'AFTERNOON',
    Evening: 'EVENING',
    Morning: 'MORNING',
    Night: 'NIGHT',
    Now: 'NOW'
};
exports.DeeplinkShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.DeeplinkShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.DividerApiGroupTypeEnum = {
    Divider: 'DIVIDER',
    Expandable: 'EXPANDABLE',
    Subview: 'SUBVIEW'
};
exports.DividerApi1GroupTypeEnum = {
    Divider: 'DIVIDER',
    Expandable: 'EXPANDABLE',
    Subview: 'SUBVIEW'
};
exports.DividerElementApiTypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.DividerElementApi1TypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.ElementApiTypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.EntityEntityTypeEnum = {
    Event: 'EVENT',
    Movie: 'MOVIE',
    News: 'NEWS',
    Sports: 'SPORTS',
    TvNetwork: 'TV_NETWORK',
    TvShow: 'TV_SHOW',
    Unspecified: 'UNSPECIFIED',
    Video: 'VIDEO'
};
exports.EpisodeApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.EpisodeApiContentProviderEnum = {
    Amediateka: 'AMEDIATEKA',
    Ivi: 'IVI',
    Kion: 'KION',
    Mts: 'MTS',
    Start: 'START'
};
exports.EpisodeInfoApiBoughtStatusEnum = {
    Blocked: 'BLOCKED',
    Free: 'FREE',
    Fvod: 'FVOD',
    IsAvod: 'IS_AVOD',
    PartiallyPurchased: 'PARTIALLY_PURCHASED',
    Purchased: 'PURCHASED',
    Unpurchased: 'UNPURCHASED'
};
exports.EpisodeLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.EpisodeLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.ExpandableApiGroupTypeEnum = {
    Divider: 'DIVIDER',
    Expandable: 'EXPANDABLE',
    Subview: 'SUBVIEW'
};
exports.ExpandableApiItemTypeEnum = {
    Multi: 'MULTI',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.ExpandableApi1GroupTypeEnum = {
    Divider: 'DIVIDER',
    Expandable: 'EXPANDABLE',
    Subview: 'SUBVIEW'
};
exports.ExpandableApi1ItemTypeEnum = {
    Multi: 'MULTI',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.FavoriteChannelsShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.FavoriteChannelsShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.FavoriteVodShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.FavoriteVodShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.GroupElementApiGroupTypeEnum = {
    Divider: 'DIVIDER',
    Expandable: 'EXPANDABLE',
    Subview: 'SUBVIEW'
};
exports.InputElementApiTypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.InputElementApi1TypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.IntroTextApiTypeEnum = {
    AnonymousGreeting: 'ANONYMOUS_GREETING',
    PersonalGreeting: 'PERSONAL_GREETING'
};
exports.LinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.MetaResponseApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.MetaResponseApiBoughtStatusEnum = {
    Blocked: 'BLOCKED',
    Free: 'FREE',
    Fvod: 'FVOD',
    IsAvod: 'IS_AVOD',
    PartiallyPurchased: 'PARTIALLY_PURCHASED',
    Purchased: 'PURCHASED',
    Unpurchased: 'UNPURCHASED'
};
exports.MetaResponseApiContentProviderEnum = {
    Amediateka: 'AMEDIATEKA',
    Ivi: 'IVI',
    Kion: 'KION',
    Mts: 'MTS',
    Start: 'START'
};
exports.MetaResponseApiTypeEnum = {
    Movie: 'MOVIE',
    Series: 'SERIES'
};
exports.MovieContentCardApiBoughtStatusEnum = {
    Blocked: 'BLOCKED',
    Free: 'FREE',
    Fvod: 'FVOD',
    IsAvod: 'IS_AVOD',
    PartiallyPurchased: 'PARTIALLY_PURCHASED',
    Purchased: 'PURCHASED',
    Unpurchased: 'UNPURCHASED'
};
exports.MovieContentCardApiTypeEnum = {
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Season: 'SEASON',
    Series: 'SERIES'
};
exports.MovieContentCardApi1BoughtStatusEnum = {
    Blocked: 'BLOCKED',
    Free: 'FREE',
    Fvod: 'FVOD',
    IsAvod: 'IS_AVOD',
    PartiallyPurchased: 'PARTIALLY_PURCHASED',
    Purchased: 'PURCHASED',
    Unpurchased: 'UNPURCHASED'
};
exports.MovieContentCardApi1TypeEnum = {
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Season: 'SEASON',
    Series: 'SERIES'
};
exports.MovieLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.MovieLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.NowOnTvShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.NowOnTvShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.OperatorMediaQueryResponseQueryIntentEnum = {
    EntitySearch: 'ENTITY_SEARCH',
    Play: 'PLAY',
    PlayTvm: 'PLAY_TVM',
    Search: 'SEARCH',
    StartRecording: 'START_RECORDING',
    SwitchChannel: 'SWITCH_CHANNEL',
    TvGuide: 'TV_GUIDE'
};
exports.PageApiSlugEnum = {
    Main: 'MAIN',
    Movies: 'MOVIES',
    Music: 'MUSIC',
    Screensaver: 'SCREENSAVER',
    Series: 'SERIES',
    Smarthub: 'SMARTHUB',
    Tv: 'TV'
};
exports.PageInfoApiSlugEnum = {
    Main: 'MAIN',
    Movies: 'MOVIES',
    Music: 'MUSIC',
    Screensaver: 'SCREENSAVER',
    Series: 'SERIES',
    Smarthub: 'SMARTHUB',
    Tv: 'TV'
};
exports.PersonApiGenderEnum = {
    Female: 'FEMALE',
    Male: 'MALE',
    Unknown: 'UNKNOWN'
};
exports.PreferenceRequestApiResultEnum = {
    Dislike: 'DISLIKE',
    DontKnow: 'DONT_KNOW',
    Like: 'LIKE'
};
exports.ProgramLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.ProgramLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.PromoCodeLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.PromoCodeLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.PromoShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.PromoShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.RangeElementApiTypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.RangeElementApi1TypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.ResultListItemEntityTypeEnum = {
    Event: 'EVENT',
    Movie: 'MOVIE',
    News: 'NEWS',
    Sports: 'SPORTS',
    TvNetwork: 'TV_NETWORK',
    TvShow: 'TV_SHOW',
    Unspecified: 'UNSPECIFIED',
    Video: 'VIDEO'
};
exports.ResultListItemRatingEnum = {
    _0: '0+',
    _12: '12+',
    _16: '16+',
    _18: '18+',
    _6: '6+'
};
exports.ScreensaverShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.ScreensaverShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SearchCatchupsShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SearchCatchupsShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SearchChannelsShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SearchChannelsShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SearchProgramsShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SearchProgramsShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SearchVodShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SearchVodShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SeasonApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.SeasonApiBoughtStatusEnum = {
    Blocked: 'BLOCKED',
    Free: 'FREE',
    Fvod: 'FVOD',
    IsAvod: 'IS_AVOD',
    PartiallyPurchased: 'PARTIALLY_PURCHASED',
    Purchased: 'PURCHASED',
    Unpurchased: 'UNPURCHASED'
};
exports.SeasonApiContentProviderEnum = {
    Amediateka: 'AMEDIATEKA',
    Ivi: 'IVI',
    Kion: 'KION',
    Mts: 'MTS',
    Start: 'START'
};
exports.SeasonInfoApiBoughtStatusEnum = {
    Blocked: 'BLOCKED',
    Free: 'FREE',
    Fvod: 'FVOD',
    IsAvod: 'IS_AVOD',
    PartiallyPurchased: 'PARTIALLY_PURCHASED',
    Purchased: 'PURCHASED',
    Unpurchased: 'UNPURCHASED'
};
exports.SeasonLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.SeasonLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.SelectElementApiTypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.SelectElementApi1TypeEnum = {
    Action: 'ACTION',
    Checkbox: 'CHECKBOX',
    Divider: 'DIVIDER',
    Input: 'INPUT',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.SeriesContentCardApiBoughtStatusEnum = {
    Blocked: 'BLOCKED',
    Free: 'FREE',
    Fvod: 'FVOD',
    IsAvod: 'IS_AVOD',
    PartiallyPurchased: 'PARTIALLY_PURCHASED',
    Purchased: 'PURCHASED',
    Unpurchased: 'UNPURCHASED'
};
exports.SeriesContentCardApiTypeEnum = {
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Season: 'SEASON',
    Series: 'SERIES'
};
exports.SeriesContentCardApi1BoughtStatusEnum = {
    Blocked: 'BLOCKED',
    Free: 'FREE',
    Fvod: 'FVOD',
    IsAvod: 'IS_AVOD',
    PartiallyPurchased: 'PARTIALLY_PURCHASED',
    Purchased: 'PURCHASED',
    Unpurchased: 'UNPURCHASED'
};
exports.SeriesContentCardApi1TypeEnum = {
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Season: 'SEASON',
    Series: 'SERIES'
};
exports.SeriesLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.SeriesLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.ShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.ShelfBlockItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfBlockItemApiSaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfBlockItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfBlockItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfBlockItemApi1SaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfBlockItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfChannelItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfChannelItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfChannelItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfChannelItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfCoverItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfCoverItemApiShapeEnum = {
    Free: 'FREE',
    Rect: 'RECT',
    Square: 'SQUARE'
};
exports.ShelfCoverItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfCoverItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfCoverItemApi1ShapeEnum = {
    Free: 'FREE',
    Rect: 'RECT',
    Square: 'SQUARE'
};
exports.ShelfCoverItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfEpisodeItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfEpisodeItemApiSaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfEpisodeItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfEpisodeItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfEpisodeItemApi1SaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfEpisodeItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfMovieItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfMovieItemApiSaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfMovieItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfMovieItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfMovieItemApi1SaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfMovieItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfProgramItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfProgramItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfProgramItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfProgramItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfScreensaverBannerItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfScreensaverBannerItemApiSaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfScreensaverBannerItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfScreensaverBannerItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfScreensaverBannerItemApi1SaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfScreensaverBannerItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfSeasonItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfSeasonItemApiSaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfSeasonItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfSeasonItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfSeasonItemApi1SaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfSeasonItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfSeriesItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfSeriesItemApiSaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfSeriesItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfSeriesItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfSeriesItemApi1SaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfSeriesItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfSimpleBannerItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfSimpleBannerItemApiSaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfSimpleBannerItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfSimpleBannerItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfSimpleBannerItemApi1SaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfSimpleBannerItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfVideoBannerItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfVideoBannerItemApiSaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfVideoBannerItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfVideoBannerItemApi1AgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfVideoBannerItemApi1SaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfVideoBannerItemApi1TypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.ShelfVodItemApiAgeRestrictionEnum = {
    _0: '0',
    _12: '12',
    _16: '16',
    _18: '18',
    _21: '21',
    _6: '6'
};
exports.ShelfVodItemApiSaleModelsEnum = {
    Avod: 'AVOD',
    Bvod: 'BVOD',
    Carte: 'CARTE',
    Est: 'EST',
    Flive: 'FLIVE',
    Fvod: 'FVOD',
    Live: 'LIVE',
    Svod: 'SVOD',
    Tvod: 'TVOD'
};
exports.ShelfVodItemApiTypeEnum = {
    Block: 'BLOCK',
    Channel: 'CHANNEL',
    Cover: 'COVER',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Screensaver: 'SCREENSAVER',
    Season: 'SEASON',
    Series: 'SERIES',
    SimpleBanner: 'SIMPLE_BANNER',
    VideoBanner: 'VIDEO_BANNER'
};
exports.SkippingFragmentApiTypeEnum = {
    HeadCredits: 'HEAD_CREDITS',
    MiddleCredits: 'MIDDLE_CREDITS',
    Preview: 'PREVIEW',
    PrevCredits: 'PREV_CREDITS',
    SkippingFragment: 'SKIPPING_FRAGMENT',
    Splash: 'SPLASH',
    TailCredits: 'TAIL_CREDITS',
    TextCredits: 'TEXT_CREDITS'
};
exports.StructuredQueryMediaTypeEnum = {
    Event: 'EVENT',
    Movie: 'MOVIE',
    News: 'NEWS',
    Sports: 'SPORTS',
    TvNetwork: 'TV_NETWORK',
    TvShow: 'TV_SHOW',
    Unspecified: 'UNSPECIFIED',
    Video: 'VIDEO'
};
exports.StructuredQueryQueryIntentEnum = {
    EntitySearch: 'ENTITY_SEARCH',
    Play: 'PLAY',
    PlayTvm: 'PLAY_TVM',
    Search: 'SEARCH',
    StartRecording: 'START_RECORDING',
    SwitchChannel: 'SWITCH_CHANNEL',
    TvGuide: 'TV_GUIDE'
};
exports.SubViewApiGroupTypeEnum = {
    Divider: 'DIVIDER',
    Expandable: 'EXPANDABLE',
    Subview: 'SUBVIEW'
};
exports.SubViewApiItemTypeEnum = {
    Multi: 'MULTI',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.SubViewApi1GroupTypeEnum = {
    Divider: 'DIVIDER',
    Expandable: 'EXPANDABLE',
    Subview: 'SUBVIEW'
};
exports.SubViewApi1ItemTypeEnum = {
    Multi: 'MULTI',
    Range: 'RANGE',
    Select: 'SELECT'
};
exports.SubscriptionLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.SubscriptionLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.SubscriptionListLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.SubscriptionListLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.SuperShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.SuperShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.UrlLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.UrlLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.VodShelfApiTypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.VodShelfApi1TypeEnum = {
    Block: 'BLOCK',
    Bookmark: 'BOOKMARK',
    Carousel: 'CAROUSEL',
    Channels: 'CHANNELS',
    Deeplink: 'DEEPLINK',
    FavoriteChannels: 'FAVORITE_CHANNELS',
    FavoriteVod: 'FAVORITE_VOD',
    NowOnTv: 'NOW_ON_TV',
    Promo: 'PROMO',
    Screensaver: 'SCREENSAVER',
    SearchCatchups: 'SEARCH_CATCHUPS',
    SearchChannels: 'SEARCH_CHANNELS',
    SearchPrograms: 'SEARCH_PROGRAMS',
    SearchVod: 'SEARCH_VOD',
    SuperShelf: 'SUPER_SHELF',
    Vod: 'VOD'
};
exports.VodShelfLinkApiLinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
exports.VodShelfLinkApi1LinkTypeEnum = {
    Cast: 'CAST',
    Channel: 'CHANNEL',
    Episode: 'EPISODE',
    Movie: 'MOVIE',
    Program: 'PROGRAM',
    Promocode: 'PROMOCODE',
    Season: 'SEASON',
    Series: 'SERIES',
    Subscription: 'SUBSCRIPTION',
    SubscriptionList: 'SUBSCRIPTION_LIST',
    Url: 'URL',
    VodShelf: 'VOD_SHELF'
};
/**
 * ActorFrameLabelsApi - axios parameter creator
 * @export
 */
var ActorFrameLabelsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Информация о разметке актёров в кадре
         * @summary _getActorFrameLabels
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xDeviceModel Модель устройства
         * @param {number} timeframe Время кадра
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActorFrameLabels: function (xRequestId, gid, xDeviceModel, timeframe, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getActorFrameLabels', 'xRequestId', xRequestId);
                    // verify required parameter 'gid' is not null or undefined
                    (0, common_1.assertParamExists)('getActorFrameLabels', 'gid', gid);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getActorFrameLabels', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'timeframe' is not null or undefined
                    (0, common_1.assertParamExists)('getActorFrameLabels', 'timeframe', timeframe);
                    localVarPath = "/mgw-hostess/contents/{gid}/frames/{timeframe}/actors"
                        .replace("{".concat("gid", "}"), encodeURIComponent(String(gid)))
                        .replace("{".concat("timeframe", "}"), encodeURIComponent(String(timeframe)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ActorFrameLabelsApiAxiosParamCreator = ActorFrameLabelsApiAxiosParamCreator;
/**
 * ActorFrameLabelsApi - functional programming interface
 * @export
 */
var ActorFrameLabelsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ActorFrameLabelsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Информация о разметке актёров в кадре
         * @summary _getActorFrameLabels
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xDeviceModel Модель устройства
         * @param {number} timeframe Время кадра
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActorFrameLabels: function (xRequestId, gid, xDeviceModel, timeframe, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getActorFrameLabels(xRequestId, gid, xDeviceModel, timeframe, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ActorFrameLabelsApiFp = ActorFrameLabelsApiFp;
/**
 * ActorFrameLabelsApi - factory interface
 * @export
 */
var ActorFrameLabelsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ActorFrameLabelsApiFp)(configuration);
    return {
        /**
         * Информация о разметке актёров в кадре
         * @summary _getActorFrameLabels
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xDeviceModel Модель устройства
         * @param {number} timeframe Время кадра
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActorFrameLabels: function (xRequestId, gid, xDeviceModel, timeframe, options) {
            return localVarFp.getActorFrameLabels(xRequestId, gid, xDeviceModel, timeframe, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ActorFrameLabelsApiFactory = ActorFrameLabelsApiFactory;
/**
 * ActorFrameLabelsApi - object-oriented interface
 * @export
 * @class ActorFrameLabelsApi
 * @extends {BaseAPI}
 */
var ActorFrameLabelsApi = /** @class */ (function (_super) {
    __extends(ActorFrameLabelsApi, _super);
    function ActorFrameLabelsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Информация о разметке актёров в кадре
     * @summary _getActorFrameLabels
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} gid Глобальный идентификатор сущности
     * @param {string} xDeviceModel Модель устройства
     * @param {number} timeframe Время кадра
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActorFrameLabelsApi
     */
    ActorFrameLabelsApi.prototype.getActorFrameLabels = function (xRequestId, gid, xDeviceModel, timeframe, options) {
        var _this = this;
        return (0, exports.ActorFrameLabelsApiFp)(this.configuration).getActorFrameLabels(xRequestId, gid, xDeviceModel, timeframe, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ActorFrameLabelsApi;
}(base_1.BaseAPI));
exports.ActorFrameLabelsApi = ActorFrameLabelsApi;
/**
 * ContentsApi - axios parameter creator
 * @export
 */
var ContentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Получение эпизодов по gid сезона
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {number} [offset] Смещение элементов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEpisodesBySeasonGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gid' is not null or undefined
                    (0, common_1.assertParamExists)('getEpisodesBySeasonGid', 'gid', gid);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getEpisodesBySeasonGid', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getEpisodesBySeasonGid', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getEpisodesBySeasonGid', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getEpisodesBySeasonGid', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/api/content/seasons/{gid}/episodes"
                        .replace("{".concat("gid", "}"), encodeURIComponent(String(gid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Базовая информация о контенте (фильме или сериале)
         * @param {string} gid Идентификатор контента (фильм, сериал, сезон, эпизод)
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} [xDeviceId] Уникальный идентификатор устройства
         * @param {string} [xAppVersion] Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetaByGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gid' is not null or undefined
                    (0, common_1.assertParamExists)('getMetaByGid', 'gid', gid);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getMetaByGid', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getMetaByGid', 'xDeviceModel', xDeviceModel);
                    localVarPath = "/mgw-hostess/api/content/meta/{gid}"
                        .replace("{".concat("gid", "}"), encodeURIComponent(String(gid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Получение карточки контента для фильма по идентификатору фильма
         * @summary _getMovieContentCardByGid
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMovieContentCardByGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gid' is not null or undefined
                    (0, common_1.assertParamExists)('getMovieContentCardByGid', 'gid', gid);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getMovieContentCardByGid', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getMovieContentCardByGid', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getMovieContentCardByGid', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getMovieContentCardByGid', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/vods/movie/{gid}"
                        .replace("{".concat("gid", "}"), encodeURIComponent(String(gid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Получение сезонов по gid сериала
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {number} [offset] Смещение элементов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeasonsBySeriesGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gid' is not null or undefined
                    (0, common_1.assertParamExists)('getSeasonsBySeriesGid', 'gid', gid);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getSeasonsBySeriesGid', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getSeasonsBySeriesGid', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getSeasonsBySeriesGid', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getSeasonsBySeriesGid', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/api/content/series/{gid}/seasons"
                        .replace("{".concat("gid", "}"), encodeURIComponent(String(gid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Получение карточки контента для сериала по идентификатору сериала
         * @summary _getSeriesContentCardByGid
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeriesContentCardByGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gid' is not null or undefined
                    (0, common_1.assertParamExists)('getSeriesContentCardByGid', 'gid', gid);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getSeriesContentCardByGid', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getSeriesContentCardByGid', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getSeriesContentCardByGid', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getSeriesContentCardByGid', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/vods/series/{gid}"
                        .replace("{".concat("gid", "}"), encodeURIComponent(String(gid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ContentsApiAxiosParamCreator = ContentsApiAxiosParamCreator;
/**
 * ContentsApi - functional programming interface
 * @export
 */
var ContentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContentsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Получение эпизодов по gid сезона
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {number} [offset] Смещение элементов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEpisodesBySeasonGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEpisodesBySeasonGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Базовая информация о контенте (фильме или сериале)
         * @param {string} gid Идентификатор контента (фильм, сериал, сезон, эпизод)
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} [xDeviceId] Уникальный идентификатор устройства
         * @param {string} [xAppVersion] Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetaByGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMetaByGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Получение карточки контента для фильма по идентификатору фильма
         * @summary _getMovieContentCardByGid
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMovieContentCardByGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMovieContentCardByGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Получение сезонов по gid сериала
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {number} [offset] Смещение элементов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeasonsBySeriesGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSeasonsBySeriesGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Получение карточки контента для сериала по идентификатору сериала
         * @summary _getSeriesContentCardByGid
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeriesContentCardByGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSeriesContentCardByGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ContentsApiFp = ContentsApiFp;
/**
 * ContentsApi - factory interface
 * @export
 */
var ContentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContentsApiFp)(configuration);
    return {
        /**
         *
         * @summary Получение эпизодов по gid сезона
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {number} [offset] Смещение элементов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEpisodesBySeasonGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options) {
            return localVarFp.getEpisodesBySeasonGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Базовая информация о контенте (фильме или сериале)
         * @param {string} gid Идентификатор контента (фильм, сериал, сезон, эпизод)
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} [xDeviceId] Уникальный идентификатор устройства
         * @param {string} [xAppVersion] Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetaByGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return localVarFp.getMetaByGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Получение карточки контента для фильма по идентификатору фильма
         * @summary _getMovieContentCardByGid
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMovieContentCardByGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return localVarFp.getMovieContentCardByGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Получение сезонов по gid сериала
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {number} [offset] Смещение элементов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeasonsBySeriesGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options) {
            return localVarFp.getSeasonsBySeriesGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Получение карточки контента для сериала по идентификатору сериала
         * @summary _getSeriesContentCardByGid
         * @param {string} gid Глобальный идентификатор сущности
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeriesContentCardByGid: function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return localVarFp.getSeriesContentCardByGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContentsApiFactory = ContentsApiFactory;
/**
 * ContentsApi - object-oriented interface
 * @export
 * @class ContentsApi
 * @extends {BaseAPI}
 */
var ContentsApi = /** @class */ (function (_super) {
    __extends(ContentsApi, _super);
    function ContentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Получение эпизодов по gid сезона
     * @param {string} gid Глобальный идентификатор сущности
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {number} [limit] Количество элементов, которые нужно вернуть
     * @param {number} [offset] Смещение элементов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApi
     */
    ContentsApi.prototype.getEpisodesBySeasonGid = function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options) {
        var _this = this;
        return (0, exports.ContentsApiFp)(this.configuration).getEpisodesBySeasonGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Базовая информация о контенте (фильме или сериале)
     * @param {string} gid Идентификатор контента (фильм, сериал, сезон, эпизод)
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} [xDeviceId] Уникальный идентификатор устройства
     * @param {string} [xAppVersion] Версия клиентского приложения
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApi
     */
    ContentsApi.prototype.getMetaByGid = function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
        var _this = this;
        return (0, exports.ContentsApiFp)(this.configuration).getMetaByGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Получение карточки контента для фильма по идентификатору фильма
     * @summary _getMovieContentCardByGid
     * @param {string} gid Глобальный идентификатор сущности
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApi
     */
    ContentsApi.prototype.getMovieContentCardByGid = function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
        var _this = this;
        return (0, exports.ContentsApiFp)(this.configuration).getMovieContentCardByGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Получение сезонов по gid сериала
     * @param {string} gid Глобальный идентификатор сущности
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {number} [limit] Количество элементов, которые нужно вернуть
     * @param {number} [offset] Смещение элементов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApi
     */
    ContentsApi.prototype.getSeasonsBySeriesGid = function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options) {
        var _this = this;
        return (0, exports.ContentsApiFp)(this.configuration).getSeasonsBySeriesGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, limit, offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Получение карточки контента для сериала по идентификатору сериала
     * @summary _getSeriesContentCardByGid
     * @param {string} gid Глобальный идентификатор сущности
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApi
     */
    ContentsApi.prototype.getSeriesContentCardByGid = function (gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
        var _this = this;
        return (0, exports.ContentsApiFp)(this.configuration).getSeriesContentCardByGid(gid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContentsApi;
}(base_1.BaseAPI));
exports.ContentsApi = ContentsApi;
/**
 * FiltersApi - axios parameter creator
 * @export
 */
var FiltersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Получение доступных фильтров
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {string} [shelfId] Идентификатор полки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, shelfId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getFilters', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getFilters', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getFilters', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getFilters', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/filters";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (shelfId !== undefined) {
                        localVarQueryParameter['shelfId'] = shelfId;
                    }
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (ifModifiedSince != null) {
                        localVarHeaderParameter['If-Modified-Since'] = typeof ifModifiedSince === 'string'
                            ? ifModifiedSince
                            : JSON.stringify(ifModifiedSince);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Поиск контента по фильтрам
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {string} [xAreaCode] Код зоны ТВ канала
         * @param {FilterBodyApi} [filterBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, filterBodyApi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('search', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('search', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('search', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('search', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/filters/actions/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (ifModifiedSince != null) {
                        localVarHeaderParameter['If-Modified-Since'] = typeof ifModifiedSince === 'string'
                            ? ifModifiedSince
                            : JSON.stringify(ifModifiedSince);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    if (xAreaCode != null) {
                        localVarHeaderParameter['X-Area-Code'] = String(xAreaCode);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(filterBodyApi, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FiltersApiAxiosParamCreator = FiltersApiAxiosParamCreator;
/**
 * FiltersApi - functional programming interface
 * @export
 */
var FiltersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FiltersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Получение доступных фильтров
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {string} [shelfId] Идентификатор полки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, shelfId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFilters(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, shelfId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Поиск контента по фильтрам
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {string} [xAreaCode] Код зоны ТВ канала
         * @param {FilterBodyApi} [filterBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, filterBodyApi, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.search(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, filterBodyApi, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FiltersApiFp = FiltersApiFp;
/**
 * FiltersApi - factory interface
 * @export
 */
var FiltersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FiltersApiFp)(configuration);
    return {
        /**
         *
         * @summary Получение доступных фильтров
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {string} [shelfId] Идентификатор полки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilters: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, shelfId, options) {
            return localVarFp.getFilters(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, shelfId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Поиск контента по фильтрам
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {string} [xAreaCode] Код зоны ТВ канала
         * @param {FilterBodyApi} [filterBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, filterBodyApi, options) {
            return localVarFp.search(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, filterBodyApi, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FiltersApiFactory = FiltersApiFactory;
/**
 * FiltersApi - object-oriented interface
 * @export
 * @class FiltersApi
 * @extends {BaseAPI}
 */
var FiltersApi = /** @class */ (function (_super) {
    __extends(FiltersApi, _super);
    function FiltersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Получение доступных фильтров
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {string} [shelfId] Идентификатор полки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersApi
     */
    FiltersApi.prototype.getFilters = function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, shelfId, options) {
        var _this = this;
        return (0, exports.FiltersApiFp)(this.configuration).getFilters(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, shelfId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Поиск контента по фильтрам
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {string} [xAreaCode] Код зоны ТВ канала
     * @param {FilterBodyApi} [filterBodyApi]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiltersApi
     */
    FiltersApi.prototype.search = function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, filterBodyApi, options) {
        var _this = this;
        return (0, exports.FiltersApiFp)(this.configuration).search(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, filterBodyApi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FiltersApi;
}(base_1.BaseAPI));
exports.FiltersApi = FiltersApi;
/**
 * GarconControllerApi - axios parameter creator
 * @export
 */
var GarconControllerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary processRequest
         * @param {GAssistRequest} [gAssistRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processRequestUsingPOST: function (gAssistRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/mgw-hostess/api/assistant";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gAssistRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.GarconControllerApiAxiosParamCreator = GarconControllerApiAxiosParamCreator;
/**
 * GarconControllerApi - functional programming interface
 * @export
 */
var GarconControllerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GarconControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary processRequest
         * @param {GAssistRequest} [gAssistRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processRequestUsingPOST: function (gAssistRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processRequestUsingPOST(gAssistRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GarconControllerApiFp = GarconControllerApiFp;
/**
 * GarconControllerApi - factory interface
 * @export
 */
var GarconControllerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GarconControllerApiFp)(configuration);
    return {
        /**
         *
         * @summary processRequest
         * @param {GAssistRequest} [gAssistRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processRequestUsingPOST: function (gAssistRequest, options) {
            return localVarFp.processRequestUsingPOST(gAssistRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GarconControllerApiFactory = GarconControllerApiFactory;
/**
 * GarconControllerApi - object-oriented interface
 * @export
 * @class GarconControllerApi
 * @extends {BaseAPI}
 */
var GarconControllerApi = /** @class */ (function (_super) {
    __extends(GarconControllerApi, _super);
    function GarconControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary processRequest
     * @param {GAssistRequest} [gAssistRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GarconControllerApi
     */
    GarconControllerApi.prototype.processRequestUsingPOST = function (gAssistRequest, options) {
        var _this = this;
        return (0, exports.GarconControllerApiFp)(this.configuration).processRequestUsingPOST(gAssistRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GarconControllerApi;
}(base_1.BaseAPI));
exports.GarconControllerApi = GarconControllerApi;
/**
 * OnboardingApi - axios parameter creator
 * @export
 */
var OnboardingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Получение онбординга (подборки)
         * @param {string} gid glo id онбординга
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewarmOnboarding: function (gid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gid' is not null or undefined
                    (0, common_1.assertParamExists)('rewarmOnboarding', 'gid', gid);
                    localVarPath = "/mgw-hostess/onboarding/rewarm/{gid}"
                        .replace("{".concat("gid", "}"), encodeURIComponent(String(gid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.OnboardingApiAxiosParamCreator = OnboardingApiAxiosParamCreator;
/**
 * OnboardingApi - functional programming interface
 * @export
 */
var OnboardingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OnboardingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Получение онбординга (подборки)
         * @param {string} gid glo id онбординга
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewarmOnboarding: function (gid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rewarmOnboarding(gid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OnboardingApiFp = OnboardingApiFp;
/**
 * OnboardingApi - factory interface
 * @export
 */
var OnboardingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OnboardingApiFp)(configuration);
    return {
        /**
         *
         * @summary Получение онбординга (подборки)
         * @param {string} gid glo id онбординга
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rewarmOnboarding: function (gid, options) {
            return localVarFp.rewarmOnboarding(gid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OnboardingApiFactory = OnboardingApiFactory;
/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
var OnboardingApi = /** @class */ (function (_super) {
    __extends(OnboardingApi, _super);
    function OnboardingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Получение онбординга (подборки)
     * @param {string} gid glo id онбординга
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    OnboardingApi.prototype.rewarmOnboarding = function (gid, options) {
        var _this = this;
        return (0, exports.OnboardingApiFp)(this.configuration).rewarmOnboarding(gid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OnboardingApi;
}(base_1.BaseAPI));
exports.OnboardingApi = OnboardingApi;
/**
 * PagesApi - axios parameter creator
 * @export
 */
var PagesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Возвращает страницу по названию страницы
         * @summary _getPageBySlug
         * @param {string} slug Имя страницы
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {number} [offset] Смещение элементов
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageBySlug: function (slug, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'slug' is not null or undefined
                    (0, common_1.assertParamExists)('getPageBySlug', 'slug', slug);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getPageBySlug', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getPageBySlug', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getPageBySlug', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getPageBySlug', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/pages/{slug}"
                        .replace("{".concat("slug", "}"), encodeURIComponent(String(slug)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (ifModifiedSince != null) {
                        localVarHeaderParameter['If-Modified-Since'] = typeof ifModifiedSince === 'string'
                            ? ifModifiedSince
                            : JSON.stringify(ifModifiedSince);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Возвращает минимальную информацию о доступных страницах для клиента, а также видеоприветствие
         * @summary _getPagesInfo
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagesInfo: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getPagesInfo', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getPagesInfo', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getPagesInfo', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getPagesInfo', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/init";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (ifModifiedSince != null) {
                        localVarHeaderParameter['If-Modified-Since'] = typeof ifModifiedSince === 'string'
                            ? ifModifiedSince
                            : JSON.stringify(ifModifiedSince);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PagesApiAxiosParamCreator = PagesApiAxiosParamCreator;
/**
 * PagesApi - functional programming interface
 * @export
 */
var PagesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PagesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Возвращает страницу по названию страницы
         * @summary _getPageBySlug
         * @param {string} slug Имя страницы
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {number} [offset] Смещение элементов
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageBySlug: function (slug, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPageBySlug(slug, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Возвращает минимальную информацию о доступных страницах для клиента, а также видеоприветствие
         * @summary _getPagesInfo
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagesInfo: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPagesInfo(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PagesApiFp = PagesApiFp;
/**
 * PagesApi - factory interface
 * @export
 */
var PagesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PagesApiFp)(configuration);
    return {
        /**
         * Возвращает страницу по названию страницы
         * @summary _getPageBySlug
         * @param {string} slug Имя страницы
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {number} [offset] Смещение элементов
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageBySlug: function (slug, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return localVarFp.getPageBySlug(slug, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Возвращает минимальную информацию о доступных страницах для клиента, а также видеоприветствие
         * @summary _getPagesInfo
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPagesInfo: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return localVarFp.getPagesInfo(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PagesApiFactory = PagesApiFactory;
/**
 * PagesApi - object-oriented interface
 * @export
 * @class PagesApi
 * @extends {BaseAPI}
 */
var PagesApi = /** @class */ (function (_super) {
    __extends(PagesApi, _super);
    function PagesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Возвращает страницу по названию страницы
     * @summary _getPageBySlug
     * @param {string} slug Имя страницы
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {number} [offset] Смещение элементов
     * @param {number} [limit] Количество элементов, которые нужно вернуть
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PagesApi
     */
    PagesApi.prototype.getPageBySlug = function (slug, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
        var _this = this;
        return (0, exports.PagesApiFp)(this.configuration).getPageBySlug(slug, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Возвращает минимальную информацию о доступных страницах для клиента, а также видеоприветствие
     * @summary _getPagesInfo
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PagesApi
     */
    PagesApi.prototype.getPagesInfo = function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
        var _this = this;
        return (0, exports.PagesApiFp)(this.configuration).getPagesInfo(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PagesApi;
}(base_1.BaseAPI));
exports.PagesApi = PagesApi;
/**
 * PreferenceApi - axios parameter creator
 * @export
 */
var PreferenceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Получение оценок пользователя и возвращение элемента опроса
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {PreferenceRequestApi} [preferenceRequestApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, preferenceRequestApi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getSurvey', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getSurvey', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getSurvey', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getSurvey', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/api/preference/actions/result";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(preferenceRequestApi, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PreferenceApiAxiosParamCreator = PreferenceApiAxiosParamCreator;
/**
 * PreferenceApi - functional programming interface
 * @export
 */
var PreferenceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PreferenceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Получение оценок пользователя и возвращение элемента опроса
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {PreferenceRequestApi} [preferenceRequestApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, preferenceRequestApi, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSurvey(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, preferenceRequestApi, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PreferenceApiFp = PreferenceApiFp;
/**
 * PreferenceApi - factory interface
 * @export
 */
var PreferenceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PreferenceApiFp)(configuration);
    return {
        /**
         *
         * @summary Получение оценок пользователя и возвращение элемента опроса
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {PreferenceRequestApi} [preferenceRequestApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, preferenceRequestApi, options) {
            return localVarFp.getSurvey(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, preferenceRequestApi, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PreferenceApiFactory = PreferenceApiFactory;
/**
 * PreferenceApi - object-oriented interface
 * @export
 * @class PreferenceApi
 * @extends {BaseAPI}
 */
var PreferenceApi = /** @class */ (function (_super) {
    __extends(PreferenceApi, _super);
    function PreferenceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Получение оценок пользователя и возвращение элемента опроса
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {PreferenceRequestApi} [preferenceRequestApi]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferenceApi
     */
    PreferenceApi.prototype.getSurvey = function (xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, preferenceRequestApi, options) {
        var _this = this;
        return (0, exports.PreferenceApiFp)(this.configuration).getSurvey(xRequestId, xDeviceModel, xDeviceId, xAppVersion, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, preferenceRequestApi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PreferenceApi;
}(base_1.BaseAPI));
exports.PreferenceApi = PreferenceApi;
/**
 * RatingApi - axios parameter creator
 * @export
 */
var RatingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Сохранение рейтинга пользователя
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {RatingRequestApi} [ratingRequestApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRating: function (xHuaweiProfileId, xRequestId, xDeviceModel, ratingRequestApi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xHuaweiProfileId' is not null or undefined
                    (0, common_1.assertParamExists)('saveRating', 'xHuaweiProfileId', xHuaweiProfileId);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('saveRating', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('saveRating', 'xDeviceModel', xDeviceModel);
                    localVarPath = "/mgw-hostess/api/vods/rating";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ratingRequestApi, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.RatingApiAxiosParamCreator = RatingApiAxiosParamCreator;
/**
 * RatingApi - functional programming interface
 * @export
 */
var RatingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RatingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Сохранение рейтинга пользователя
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {RatingRequestApi} [ratingRequestApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRating: function (xHuaweiProfileId, xRequestId, xDeviceModel, ratingRequestApi, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveRating(xHuaweiProfileId, xRequestId, xDeviceModel, ratingRequestApi, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RatingApiFp = RatingApiFp;
/**
 * RatingApi - factory interface
 * @export
 */
var RatingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RatingApiFp)(configuration);
    return {
        /**
         *
         * @summary Сохранение рейтинга пользователя
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {RatingRequestApi} [ratingRequestApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRating: function (xHuaweiProfileId, xRequestId, xDeviceModel, ratingRequestApi, options) {
            return localVarFp.saveRating(xHuaweiProfileId, xRequestId, xDeviceModel, ratingRequestApi, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RatingApiFactory = RatingApiFactory;
/**
 * RatingApi - object-oriented interface
 * @export
 * @class RatingApi
 * @extends {BaseAPI}
 */
var RatingApi = /** @class */ (function (_super) {
    __extends(RatingApi, _super);
    function RatingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Сохранение рейтинга пользователя
     * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {RatingRequestApi} [ratingRequestApi]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.saveRating = function (xHuaweiProfileId, xRequestId, xDeviceModel, ratingRequestApi, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).saveRating(xHuaweiProfileId, xRequestId, xDeviceModel, ratingRequestApi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RatingApi;
}(base_1.BaseAPI));
exports.RatingApi = RatingApi;
/**
 * RemindersApi - axios parameter creator
 * @export
 */
var RemindersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Удаление напоминаний
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {DeleteReminderBodyApi} [deleteReminderBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReminders: function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, deleteReminderBodyApi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteReminders', 'xRequestId', xRequestId);
                    // verify required parameter 'xHuaweiProfileId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteReminders', 'xHuaweiProfileId', xHuaweiProfileId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('deleteReminders', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteReminders', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('deleteReminders', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/api/reminders/programs/actions/delete-bulk";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteReminderBodyApi, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Получение списка напоминаний
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {number} [offset] Смещение элементов
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReminders: function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xAgeRestriction, xExperiments, acceptLanguage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getReminders', 'xRequestId', xRequestId);
                    // verify required parameter 'xHuaweiProfileId' is not null or undefined
                    (0, common_1.assertParamExists)('getReminders', 'xHuaweiProfileId', xHuaweiProfileId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getReminders', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getReminders', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getReminders', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/api/reminders/programs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Создание напоминания
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {SaveReminderBodyApi} [saveReminderBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReminder: function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, saveReminderBodyApi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('saveReminder', 'xRequestId', xRequestId);
                    // verify required parameter 'xHuaweiProfileId' is not null or undefined
                    (0, common_1.assertParamExists)('saveReminder', 'xHuaweiProfileId', xHuaweiProfileId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('saveReminder', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('saveReminder', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('saveReminder', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/api/reminders/programs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saveReminderBodyApi, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Обновление напоминания
         * @param {string} reminderId Идентификатор напоминания
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {UpdateReminderBodyApi} [updateReminderBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReminder: function (reminderId, xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, updateReminderBodyApi, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'reminderId' is not null or undefined
                    (0, common_1.assertParamExists)('updateReminder', 'reminderId', reminderId);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('updateReminder', 'xRequestId', xRequestId);
                    // verify required parameter 'xHuaweiProfileId' is not null or undefined
                    (0, common_1.assertParamExists)('updateReminder', 'xHuaweiProfileId', xHuaweiProfileId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('updateReminder', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('updateReminder', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('updateReminder', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/api/reminders/programs/{reminderId}"
                        .replace("{".concat("reminderId", "}"), encodeURIComponent(String(reminderId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateReminderBodyApi, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.RemindersApiAxiosParamCreator = RemindersApiAxiosParamCreator;
/**
 * RemindersApi - functional programming interface
 * @export
 */
var RemindersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RemindersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Удаление напоминаний
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {DeleteReminderBodyApi} [deleteReminderBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReminders: function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, deleteReminderBodyApi, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteReminders(xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, deleteReminderBodyApi, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Получение списка напоминаний
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {number} [offset] Смещение элементов
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReminders: function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xAgeRestriction, xExperiments, acceptLanguage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getReminders(xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xAgeRestriction, xExperiments, acceptLanguage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Создание напоминания
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {SaveReminderBodyApi} [saveReminderBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReminder: function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, saveReminderBodyApi, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveReminder(xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, saveReminderBodyApi, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Обновление напоминания
         * @param {string} reminderId Идентификатор напоминания
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {UpdateReminderBodyApi} [updateReminderBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReminder: function (reminderId, xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, updateReminderBodyApi, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateReminder(reminderId, xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, updateReminderBodyApi, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RemindersApiFp = RemindersApiFp;
/**
 * RemindersApi - factory interface
 * @export
 */
var RemindersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RemindersApiFp)(configuration);
    return {
        /**
         *
         * @summary Удаление напоминаний
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {DeleteReminderBodyApi} [deleteReminderBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReminders: function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, deleteReminderBodyApi, options) {
            return localVarFp.deleteReminders(xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, deleteReminderBodyApi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Получение списка напоминаний
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {number} [offset] Смещение элементов
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReminders: function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xAgeRestriction, xExperiments, acceptLanguage, options) {
            return localVarFp.getReminders(xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xAgeRestriction, xExperiments, acceptLanguage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Создание напоминания
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {SaveReminderBodyApi} [saveReminderBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReminder: function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, saveReminderBodyApi, options) {
            return localVarFp.saveReminder(xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, saveReminderBodyApi, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Обновление напоминания
         * @param {string} reminderId Идентификатор напоминания
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {UpdateReminderBodyApi} [updateReminderBodyApi]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReminder: function (reminderId, xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, updateReminderBodyApi, options) {
            return localVarFp.updateReminder(reminderId, xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, updateReminderBodyApi, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RemindersApiFactory = RemindersApiFactory;
/**
 * RemindersApi - object-oriented interface
 * @export
 * @class RemindersApi
 * @extends {BaseAPI}
 */
var RemindersApi = /** @class */ (function (_super) {
    __extends(RemindersApi, _super);
    function RemindersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Удаление напоминаний
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {DeleteReminderBodyApi} [deleteReminderBodyApi]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemindersApi
     */
    RemindersApi.prototype.deleteReminders = function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, deleteReminderBodyApi, options) {
        var _this = this;
        return (0, exports.RemindersApiFp)(this.configuration).deleteReminders(xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, deleteReminderBodyApi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Получение списка напоминаний
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {number} [offset] Смещение элементов
     * @param {number} [limit] Количество элементов, которые нужно вернуть
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemindersApi
     */
    RemindersApi.prototype.getReminders = function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xAgeRestriction, xExperiments, acceptLanguage, options) {
        var _this = this;
        return (0, exports.RemindersApiFp)(this.configuration).getReminders(xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xAgeRestriction, xExperiments, acceptLanguage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Создание напоминания
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {SaveReminderBodyApi} [saveReminderBodyApi]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemindersApi
     */
    RemindersApi.prototype.saveReminder = function (xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, saveReminderBodyApi, options) {
        var _this = this;
        return (0, exports.RemindersApiFp)(this.configuration).saveReminder(xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, saveReminderBodyApi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Обновление напоминания
     * @param {string} reminderId Идентификатор напоминания
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xHuaweiProfileId Идентификатор профиля в Huawei
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {UpdateReminderBodyApi} [updateReminderBodyApi]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemindersApi
     */
    RemindersApi.prototype.updateReminder = function (reminderId, xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, updateReminderBodyApi, options) {
        var _this = this;
        return (0, exports.RemindersApiFp)(this.configuration).updateReminder(reminderId, xRequestId, xHuaweiProfileId, xDeviceModel, xDeviceId, xAppVersion, xAgeRestriction, xExperiments, acceptLanguage, updateReminderBodyApi, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RemindersApi;
}(base_1.BaseAPI));
exports.RemindersApi = RemindersApi;
/**
 * SearchApi - axios parameter creator
 * @export
 */
var SearchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Получение списка телеканалов, фильмов и сериалов соответствующих параметрам
         * @param {string} term Текст запроса
         * @param {number} limit Количество элементов, которые нужно вернуть
         * @param {string} timezone Таймзона клиента
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'SEARCH_CATCHUPS' | 'SEARCH_CHANNELS' | 'SEARCH_PROGRAMS' | 'SEARCH_VOD'} [type] Тип контента
         * @param {number} [offset] Смещение элементов
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {string} [xAreaCode] Код зоны ТВ канала
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchResult: function (term, limit, timezone, xRequestId, xDeviceModel, xDeviceId, xAppVersion, type, offset, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'term' is not null or undefined
                    (0, common_1.assertParamExists)('getSearchResult', 'term', term);
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getSearchResult', 'limit', limit);
                    // verify required parameter 'timezone' is not null or undefined
                    (0, common_1.assertParamExists)('getSearchResult', 'timezone', timezone);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getSearchResult', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getSearchResult', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getSearchResult', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getSearchResult', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (term !== undefined) {
                        localVarQueryParameter['term'] = term;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (timezone !== undefined) {
                        localVarQueryParameter['timezone'] = timezone;
                    }
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    if (xAreaCode != null) {
                        localVarHeaderParameter['X-Area-Code'] = String(xAreaCode);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SearchApiAxiosParamCreator = SearchApiAxiosParamCreator;
/**
 * SearchApi - functional programming interface
 * @export
 */
var SearchApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SearchApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Получение списка телеканалов, фильмов и сериалов соответствующих параметрам
         * @param {string} term Текст запроса
         * @param {number} limit Количество элементов, которые нужно вернуть
         * @param {string} timezone Таймзона клиента
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'SEARCH_CATCHUPS' | 'SEARCH_CHANNELS' | 'SEARCH_PROGRAMS' | 'SEARCH_VOD'} [type] Тип контента
         * @param {number} [offset] Смещение элементов
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {string} [xAreaCode] Код зоны ТВ канала
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchResult: function (term, limit, timezone, xRequestId, xDeviceModel, xDeviceId, xAppVersion, type, offset, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSearchResult(term, limit, timezone, xRequestId, xDeviceModel, xDeviceId, xAppVersion, type, offset, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SearchApiFp = SearchApiFp;
/**
 * SearchApi - factory interface
 * @export
 */
var SearchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SearchApiFp)(configuration);
    return {
        /**
         *
         * @summary Получение списка телеканалов, фильмов и сериалов соответствующих параметрам
         * @param {string} term Текст запроса
         * @param {number} limit Количество элементов, которые нужно вернуть
         * @param {string} timezone Таймзона клиента
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {'SEARCH_CATCHUPS' | 'SEARCH_CHANNELS' | 'SEARCH_PROGRAMS' | 'SEARCH_VOD'} [type] Тип контента
         * @param {number} [offset] Смещение элементов
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {string} [xAreaCode] Код зоны ТВ канала
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchResult: function (term, limit, timezone, xRequestId, xDeviceModel, xDeviceId, xAppVersion, type, offset, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, options) {
            return localVarFp.getSearchResult(term, limit, timezone, xRequestId, xDeviceModel, xDeviceId, xAppVersion, type, offset, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SearchApiFactory = SearchApiFactory;
/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
var SearchApi = /** @class */ (function (_super) {
    __extends(SearchApi, _super);
    function SearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Получение списка телеканалов, фильмов и сериалов соответствующих параметрам
     * @param {string} term Текст запроса
     * @param {number} limit Количество элементов, которые нужно вернуть
     * @param {string} timezone Таймзона клиента
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {'SEARCH_CATCHUPS' | 'SEARCH_CHANNELS' | 'SEARCH_PROGRAMS' | 'SEARCH_VOD'} [type] Тип контента
     * @param {number} [offset] Смещение элементов
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {string} [xAreaCode] Код зоны ТВ канала
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    SearchApi.prototype.getSearchResult = function (term, limit, timezone, xRequestId, xDeviceModel, xDeviceId, xAppVersion, type, offset, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, options) {
        var _this = this;
        return (0, exports.SearchApiFp)(this.configuration).getSearchResult(term, limit, timezone, xRequestId, xDeviceModel, xDeviceId, xAppVersion, type, offset, xHuaweiProfileId, xAgeRestriction, xExperiments, xAcceptImage, xAreaCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SearchApi;
}(base_1.BaseAPI));
exports.SearchApi = SearchApi;
/**
 * ShelvesApi - axios parameter creator
 * @export
 */
var ShelvesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Возвращает полку по идентификатору
         * @summary _getShelfByGid
         * @param {string} shelfGid Идентификатор полки
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {number} [offset] Смещение элементов
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShelfByGid: function (shelfGid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shelfGid' is not null or undefined
                    (0, common_1.assertParamExists)('getShelfByGid', 'shelfGid', shelfGid);
                    // verify required parameter 'xRequestId' is not null or undefined
                    (0, common_1.assertParamExists)('getShelfByGid', 'xRequestId', xRequestId);
                    // verify required parameter 'xDeviceModel' is not null or undefined
                    (0, common_1.assertParamExists)('getShelfByGid', 'xDeviceModel', xDeviceModel);
                    // verify required parameter 'xDeviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getShelfByGid', 'xDeviceId', xDeviceId);
                    // verify required parameter 'xAppVersion' is not null or undefined
                    (0, common_1.assertParamExists)('getShelfByGid', 'xAppVersion', xAppVersion);
                    localVarPath = "/mgw-hostess/shelves/{shelfGid}"
                        .replace("{".concat("shelfGid", "}"), encodeURIComponent(String(shelfGid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (xRequestId != null) {
                        localVarHeaderParameter['X-Request-Id'] = String(xRequestId);
                    }
                    if (xDeviceModel != null) {
                        localVarHeaderParameter['X-Device-Model'] = String(xDeviceModel);
                    }
                    if (xDeviceId != null) {
                        localVarHeaderParameter['X-Device-Id'] = String(xDeviceId);
                    }
                    if (xAppVersion != null) {
                        localVarHeaderParameter['X-App-Version'] = String(xAppVersion);
                    }
                    if (xHuaweiProfileId != null) {
                        localVarHeaderParameter['X-Huawei-Profile-Id'] = String(xHuaweiProfileId);
                    }
                    if (ifModifiedSince != null) {
                        localVarHeaderParameter['If-Modified-Since'] = typeof ifModifiedSince === 'string'
                            ? ifModifiedSince
                            : JSON.stringify(ifModifiedSince);
                    }
                    if (xAgeRestriction != null) {
                        localVarHeaderParameter['X-Age-Restriction'] = String(xAgeRestriction);
                    }
                    if (xExperiments != null) {
                        localVarHeaderParameter['X-Experiments'] = String(xExperiments);
                    }
                    if (acceptLanguage != null) {
                        localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
                    }
                    if (xAcceptImage != null) {
                        localVarHeaderParameter['X-Accept-Image'] = String(xAcceptImage);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ShelvesApiAxiosParamCreator = ShelvesApiAxiosParamCreator;
/**
 * ShelvesApi - functional programming interface
 * @export
 */
var ShelvesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShelvesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Возвращает полку по идентификатору
         * @summary _getShelfByGid
         * @param {string} shelfGid Идентификатор полки
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {number} [offset] Смещение элементов
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShelfByGid: function (shelfGid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getShelfByGid(shelfGid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShelvesApiFp = ShelvesApiFp;
/**
 * ShelvesApi - factory interface
 * @export
 */
var ShelvesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShelvesApiFp)(configuration);
    return {
        /**
         * Возвращает полку по идентификатору
         * @summary _getShelfByGid
         * @param {string} shelfGid Идентификатор полки
         * @param {string} xRequestId Уникальный идентификатор запроса
         * @param {string} xDeviceModel Модель устройства
         * @param {string} xDeviceId Уникальный идентификатор устройства
         * @param {string} xAppVersion Версия клиентского приложения
         * @param {number} [offset] Смещение элементов
         * @param {number} [limit] Количество элементов, которые нужно вернуть
         * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
         * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
         * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
         * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
         * @param {string} [acceptLanguage] Язык, который понимает клиент
         * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShelfByGid: function (shelfGid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
            return localVarFp.getShelfByGid(shelfGid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShelvesApiFactory = ShelvesApiFactory;
/**
 * ShelvesApi - object-oriented interface
 * @export
 * @class ShelvesApi
 * @extends {BaseAPI}
 */
var ShelvesApi = /** @class */ (function (_super) {
    __extends(ShelvesApi, _super);
    function ShelvesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Возвращает полку по идентификатору
     * @summary _getShelfByGid
     * @param {string} shelfGid Идентификатор полки
     * @param {string} xRequestId Уникальный идентификатор запроса
     * @param {string} xDeviceModel Модель устройства
     * @param {string} xDeviceId Уникальный идентификатор устройства
     * @param {string} xAppVersion Версия клиентского приложения
     * @param {number} [offset] Смещение элементов
     * @param {number} [limit] Количество элементов, которые нужно вернуть
     * @param {string} [xHuaweiProfileId] Идентификатор профиля в Huawei
     * @param {string} [ifModifiedSince] Дата и время последнего запроса (для 304 Not Modified)
     * @param {'0' | '12' | '16' | '18' | '21' | '6'} [xAgeRestriction] Возрастное ограничение на профиль: 0 - до 6 лет; 6 - до 12 лет; 12 - до 16 лет; 16 - до 18 лет; 18 - до 21 года; 21 - без ограничений
     * @param {string} [xExperiments] Эксперимент для ручной отладки (json)
     * @param {string} [acceptLanguage] Язык, который понимает клиент
     * @param {string} [xAcceptImage] Форматы изображений, которые поддерживает устройство
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShelvesApi
     */
    ShelvesApi.prototype.getShelfByGid = function (shelfGid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options) {
        var _this = this;
        return (0, exports.ShelvesApiFp)(this.configuration).getShelfByGid(shelfGid, xRequestId, xDeviceModel, xDeviceId, xAppVersion, offset, limit, xHuaweiProfileId, ifModifiedSince, xAgeRestriction, xExperiments, acceptLanguage, xAcceptImage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShelvesApi;
}(base_1.BaseAPI));
exports.ShelvesApi = ShelvesApi;
